import { useTranslation } from 'next-i18next';
const useFilterOptionValue = (options, filterName = '') => {
  const {
    t
  } = useTranslation('filters');
  return (optionId: string): string => {
    const {
      name,
      featureValueDescriptive
    } = options[optionId];
    if (featureValueDescriptive) return featureValueDescriptive;
    if (filterName === 'BASE_DATA__FLAGS') return t(optionId.toLowerCase());
    return name;
  };
};
export default useFilterOptionValue;